/**
 * Created by admin on 2018/7/31.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import moment from 'moment';
import _ from 'lodash';

class MonthCalendar extends PureComponent {
  constructor() {
    super();
    this.state = {
      checked: false
    };
  }

  render() {
    const { month, weekStr, holidays, clickDay, year } = this.props;
    // 深度拷贝一份周对象，然后把周日放在前面
    const weekarr = _.cloneDeep(weekStr);
    weekarr.unshift(weekarr.pop());

    const yyyymm = `${year}-${month}`;

    const days = moment(yyyymm, 'YYYY-MM').daysInMonth();
    // Moment的ISOweekDay，周一到周日是1-7
    const bWeekDay = moment(`${yyyymm}-01`).isoWeekday();
    const eWeekDay = moment(`${yyyymm}-${days}`).isoWeekday();
    // 在第一天和最后一天前后填充满一整周
    const bFillDays = bWeekDay === 7 ? 0 : bWeekDay;
    const eFillDays = eWeekDay === 7 ? 6 : 6 - eWeekDay;
    // 产生首尾空的子数组
    const bSubArr = bFillDays === 0 ? [] : new Array(bFillDays).fill('');
    const eSubArr = eFillDays === 0 ? [] : new Array(eFillDays).fill('');
    const mainArr = new Array(days).fill('').map((d, i) => i + 1);
    // 合并成为一个完整的月视图
    const monthDays = [];
    monthDays.push(...bSubArr);
    monthDays.push(...mainArr);
    monthDays.push(...eSubArr);

    return (
      <div className="month-calendar">
        <div className="month-title">{`${year}-${month}`}</div>
        <div className="week-title">
          {weekarr.map((w, i) => (
            <span className={`${i > 0 ? 'left-line' : ''}`} key={Math.random()}>
              {w.sub}
            </span>
          ))}
        </div>
        <div className="month-body">
          {monthDays.map((d, i) => {
            const classArr = [];
            let dayBlock = <span key={Math.random()}>{d}</span>;
            if (d > 0) {
              const todayStr = `${yyyymm}-${d >= 10 ? '' : '0'}${d}`;
              const isPassed = moment().isAfter(todayStr, 'day');

              classArr.push(isPassed ? 'passed-day' : 'have-day');
              if (holidays && holidays.hasOwnProperty(todayStr)) {
                classArr.push(isPassed ? 'passed-holiday' : 'is-holiday');
              }

              dayBlock = (
                <span
                  key={Math.random()}
                  className={classArr.join(' ')}
                  onClick={e => {
                    e.stopPropagation();
                    !isPassed && clickDay(todayStr);
                  }}
                >
                  {d}
                </span>
              );
            }
            return dayBlock;
          })}
        </div>
      </div>
    );
  }
}

export default connect()(MonthCalendar);



// WEBPACK FOOTER //
// ./src/components/account/MonthCalendar.js